<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
    <v-card-title class="headline">
        {{label}}
        <v-icon
            v-if="help_text && help_text != ''"
            right
            style="pointer-events: auto;"
            v-on:click="onClickShowHelpText()"
        >
            mdi-information-outline
        </v-icon>
    </v-card-title>

    <v-card-text>
        
        <v-form
            v-model="valid"
        >

        <m-text-field
            v-if="!show_slider"
            :label="label"
            v-model="value"
            autofocus
            :rules="rules"
            :hint="hint"
            @keydown.enter="$event.preventDefault(); onOk();"
            ref="my_field"
            emoji
        />

        <v-slider
            v-if="show_slider"
            :label="label"
            :min="slider_min"
            :max="slider_max"
            :step="slider_step"
            thumb-label="always"
            style="margin-top: 25px"
            v-model="value"
        />


        <div
            v-if="edit_help_text != null"
            v-html="edit_help_text"
        >

        </div>
            
        </v-form>

    </v-card-text>

    <v-card-actions>
        <v-btn
            v-if="unset_label != null"
            text
            v-on:click="onClickUnset"
        >
            {{unset_label}}
        </v-btn>

        <v-btn
            v-if="default_value != null"
            text
            v-on:click="onClickReset"
        >
            Reset to Default
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        rules: {
            type: Array,
            default: function () { return []; },
        },

        unset_label: {
            type: String,
            default: function() { return null; }
        },

        slider_min: {
            type: [Number,String],
            default: function() { return null; }
        },

        slider_max: {
            type: [Number,String],
            default: function() { return null; }
        },

        slider_step: {
            type: [Number,String],
            default: function() { return null; }
        },

        default_value: {
            type: [Number, String],
            default: function() { return null; }
        },

        edit_help_text: {
            type: String,
            default: function() { return null; }
        }
    },

    data() {
        return {
            dialog: false,
            label: 'field',
            value: '',
            valid: false,
            hint: null,
            help_text: null,
            picker_style: null,
        }
    },

    methods: {
        showDialog(label, value, hint, help_text)
        {
            this.label = label;
            this.value = value;
            this.dialog = true; 
            this.hint = hint;
            this.help_text = help_text;
        },

        onClickShowHelpText()
        {
            this.$rc.alert('Additional Information', this.help_text);
        },
        
        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.value);
        },

        onClickUnset()
        {
            this.dialog = false;
            this.$emit('ok',null);
        },

        onClickReset()
        {
            this.value = this.default_value;
        },
    },

    computed: {
        show_slider() {
            return this.slider_min != null && this.slider_max != null && this.slider_step != null; 
        }
    },
}
</script>

<style lang="scss" scoped>

</style>